<script lang="typescript">
    import { PuzzleAttempt } from "./puzzle";
    import type { Puzzle} from './puzzle';
    import { fade } from 'svelte/transition';

    import ModalPanel from "./components/ModalPanel.svelte";
    import { createEventDispatcher, onMount } from "svelte";
    import Board from "./Board.svelte";

    const dispatch = createEventDispatcher();

    export let step = 0;
    let step_version = 0;

    function close() {
        dispatch("close");
        step_version++;
    }


    let puzzle:Puzzle = {
        width: 2,
        height: 2,
        clues: [
            { x: 0, y: 1, value: 2 },
            { x: 1, y: 2, value: 2 }
        ]
    }
    
    let attempt: PuzzleAttempt = new PuzzleAttempt(puzzle);


    function delay(ms:number): Promise<void> {
        return new Promise((resolve) => {
            setTimeout(() => resolve(), ms);
        })
    }

    //  / \
    //  / \
    // 1 = /  2 = \
    // all squares must be full
    async function step1() {
        attempt = new PuzzleAttempt(puzzle);
        const version = step_version;
        await delay(2000);  if (version != step_version) return;
        attempt.setSlant({ row: 0, col: 0 }, 1);       
        attempt = attempt;
        await delay(800);  if (version != step_version) return; 
        attempt.setSlant({ row: 0, col: 1 }, 2);  
        attempt = attempt;
        await delay(800);  if (version != step_version) return; 
        attempt.setSlant({ row: 1, col: 0 }, 1);  
        attempt = attempt;
        await delay(800);  if (version != step_version) return; 
        attempt.setSlant({ row: 1, col: 1 }, 2);  
        attempt = attempt;
    }

    // the clues in circles must have exactly that number of intersections
    async function step2() {
        attempt = new PuzzleAttempt(puzzle);
        attempt.slants = [[1, 1], [2, 2]];
        const version = step_version;
        await delay(2000);  if (version != step_version) return;
        attempt.setSlant({ row: 1, col: 0 }, 2);    
        attempt = attempt;
        await delay(800);  if (version != step_version) return; 
        attempt.setSlant({ row: 1, col: 1 }, 1);    
        attempt = attempt;
    }   


    // the lines can't make a loop
    async function step3() {
        attempt = new PuzzleAttempt(puzzle);
        attempt.slants = [[1, 2], [2, 1]];
        const version = step_version;
        await delay(2000);  if (version != step_version) return;
        attempt.setSlant({ row: 0, col: 1 }, 1);    
        attempt = attempt;
    }   

    function doStep(step_number) {
        step = step_number;
        step_version++;
        if (step_number == 1) step1();
        if (step_number == 2) step2();
        if (step_number == 3) step3();
    }

    onMount(() => doStep(step));

</script>

<ModalPanel style="top: 50%; left: 0; right: 0; transform: translateY(-50%);" on:wantClose={close}>
    <div class="how-to-play">
      <div class="step">
        {#if step == 0}
         <h1>Welcome to Naname</h1>
        {:else}
            <h2>How to play</h2>
        {/if}
        {#if step > 0 && step < 4 }
            <div class="board">
                <Board attempt={attempt} nopanzoom={true} />
            </div>
        {/if}

        {#if step == 0}
            <div class="buttons">
                <button on:click={() => doStep(1)}>How To Play</button><button on:click={() => close() }>Start</button>
            </div>
        {/if}

        {#if step == 1}
                <h3>1. Each square must have a line</h3>
                <button on:click={() => doStep(2)}>Next</button>
        {/if}
        {#if step == 2}
                <h3>2. Each circled clue must have that number of intersecting lines</h3>
                <button on:click={() => doStep(3)}>Next</button>
        {/if}
        {#if step == 3}
                <h3>3. There can be no loops</h3>
                <button on:click={() => doStep(4)}>Next</button>
        {/if}
        {#if step == 4} 
                <ol>
                    <li in:fade={{duration: 300, delay: 0}}>Fill all squares</li> 
                    <li in:fade={{duration: 300, delay: 1000}}>Satisfy Intersection Clues</li>
                    <li in:fade={{duration: 300, delay: 2000}}>No Loops</li>
                </ol>
                <h3 in:fade={{duration: 300, delay: 3000}}>That's it! Enjoy the game.</h3>
                <button on:click={close}>Continue</button>
        {/if}
        </div>
    </div>
</ModalPanel>

<style>
    .step .board {
        width: 500px;
        height: 500px;
        margin: -125px;
    }

    .step h3 {
        text-align: center;
        min-height: 4rem;
    }

    .step {
        padding: 1rem;
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
    }

    .step ol {
        font-size: 1.25rem;
    }

    .step ol li {
        margin-bottom: 0.25rem;
    }

    .step .buttons {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-top: 1rem;
        margin-bottom: 2rem;
    }

    button {
        min-width: 160px;
    }
    .buttons button + button {
        margin-left: 2rem;
    }

</style>
